module.exports = __webpack_public_path__ + "img/04.3f7ded30.jpg";